import { type FC, lazy, useMemo } from 'react';
import { yesNoValueToBoolean } from 'src/apis/hydrogen-fcfs/mappings';
import { useHydrogenFcfsRootLink } from 'src/apis/hydrogen-fcfs/use-hydrogen-fcfs-root';
import { useHydrogenOrganisationInteractingUsers } from 'src/apis/hydrogen-fcfs/use-hydrogen-organisation-interacting-users';
import { PageSpinner } from 'src/components/spinner-container';
import { useHydrogenUserInteractionOverviewPageParams } from 'src/pages/h2/fcfs/interacting-users/overview/use-page-params';

const Page = lazy(() => import('./page'));

export const HydrogenInteractingUsersOverview: FC = () => {
  const pageParams = useHydrogenUserInteractionOverviewPageParams();
  const url = useHydrogenFcfsRootLink('interactingUsersOverview');

  const requestParams = useMemo(
    () => ({
      ...pageParams.value,
      isOrganisationAssignmentActive: yesNoValueToBoolean(
        pageParams.value.isOrganisationAssignmentActive
      ),
      isUserActive: yesNoValueToBoolean(pageParams.value.isUserActive),
    }),
    [pageParams.value]
  );

  const overviewRequest = useHydrogenOrganisationInteractingUsers({
    url,
    params: requestParams,
  });

  if (!overviewRequest.response) return <PageSpinner />;

  return <Page pageParams={pageParams} overviewRequest={overviewRequest} />;
};
